import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Heading,
  Card,
  CardBody,
  CardFooter,
  Grid,
  Text,
  Spinner,
  Notification,
} from "grommet";
import { HeaderNavigation } from "../../components/Headers/AdminHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../../config/config";
import QuickStartGuideModal from "../../components/AdminPortal/QuickStartGuideModal";
import AddNewPortfolioModal from "../../components/AdminPortal/AddNewPortfolioModal";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [portfolios, setPortfolios] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAll, setShowAll] = useState(false); // State to toggle between "View More" and "View Less"
  const [showModal, setShowModal] = useState(false);
  const [showAddNewPortoflioModal, setshowAddNewPortoflioModal] = useState(false);
  const [showCreateToast, setShowCreateToast] = useState(false);
  const [createToastMessage, setCreateToastMessage] = useState("Portfolio created successfully");

  const fetchPortfolios = async () => {
    try {
      const response = await axios.get(`${API_URL}/admin/portfolios`);
      setPortfolios(
        response.data.portfolios.sort((a, b) =>
          a.portfolio_name.localeCompare(b.portfolio_name),
        ),
      );
    } catch (error) {
      console.error("Error fetching portfolios:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch portfolios from the API
  useEffect(() => {
    fetchPortfolios();
  }, []);

  const handleViewPortfolio = (portfolio_id) => {
    navigate(`/admin/portfolio/${portfolio_id}`);
  };
  

  const toggleViewMore = () => {
    setShowAll(!showAll); // Toggle between showing all portfolios and the first 8
  };

  const handlePortfolioCreated = async (message) => {
    setCreateToastMessage(message || "Portfolio created successfully");
    setShowCreateToast(true);
    await fetchPortfolios();
  };

  // Only show the first 8 portfolios unless showAll is true
  const portfoliosToDisplay = showAll ? portfolios : portfolios.slice(0, 8);

  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        {showCreateToast && (
          <Notification
            toast
            status="normal"
            message={createToastMessage}
            onClose={() => setShowCreateToast(false)}
          />
        )}
        <HeaderNavigation />
        <Box direction="row" justify="between" align="center">
          <Heading level="1" margin={{ left: "medium" }}>
            Dashboard
          </Heading>
          <Box
            pad="small"
            background="white"
            elevation="small"
            round="small"
            border={{ color: "brand", size: "xsmall" }}
            margin={{ right: "medium" }}
          >
            <Text
              color="brand"
              as="a"
              onClick={(e) => {
                e.stopPropagation();
                setShowModal(true);
              }}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              Quick Start Guide
            </Text>
          </Box>
        </Box>

        <Box
          border={{ color: "brand", size: "xsmall" }}
          width="100%"
          alignSelf="start"
        />
        <Box pad="small" align="start" margin={{ bottom: "medium" }}>
          <Box direction="row" justify="between" align="center" width="100%">
            <Heading level="1" margin={{ top: "small", left: "medium" }}>
              Portfolios
            </Heading>
            <Button
              label="+ New Portfolio"
              onClick={(e) => {
                e.stopPropagation();
                setshowAddNewPortoflioModal(true);
              }}
              secondary
              style={{ padding: "10px 30px", fontSize: "22px" }}
              
              />
          </Box>

          {isLoading ? (
            <Box
              pad="small"
              margin={{ bottom: "medium" }}
              align="center"
              width="100%"
              justify="center"
            >
              <Spinner size="medium" />
              <Text>Loading portfolios...</Text>
            </Box>
          ) : portfoliosToDisplay.length > 0 ? (
            <Box
              pad="small"
              margin={{ bottom: "medium" }}
              align="center"
              width="100%"
              justify="center"
            >
              <Grid
                columns={{ count: 4, size: "auto" }}
                gap="medium"
                pad={{ horizontal: "medium", vertical: "medium" }}
                style={{ justifyContent: "space-between" }}
                align="center"
              >
                {portfoliosToDisplay.map((portfolio) => (
                  <Card
                    key={portfolio.portfolio_id}
                    background="light-1"
                    pad="small"
                    elevation="small"
                    round="small"
                    style={{
                      border: "1px solid #E0E0E0",
                      width: "100%",
                      minWidth: "300px",
                      maxWidth: "350px",
                      minHeight: "250px",
                    }}
                  >
                    <CardBody pad="small">
                      <Box fill="vertical" justify="between" gap="small">
                        <Heading
                          level="3"
                          margin={{ top: "none", bottom: "small" }}
                          style={{ fontSize: "24px", color: "#333" }}
                        >
                          {portfolio.portfolio_name}
                        </Heading>
                        <Box gap="xsmall">
                          <Text
                            size="medium"
                            color="dark-4"
                            style={{ fontSize: "18px" }}
                          >
                            Skills:{" "}
                            <strong>{portfolio.number_of_skills}</strong>
                          </Text>
                          <Text
                            size="medium"
                            color="dark-4"
                            style={{ fontSize: "18px" }}
                          >
                            Courses:{" "}
                            <strong>{portfolio.number_of_courses}</strong>
                          </Text>
                          <Text
                            size="medium"
                            color="dark-4"
                            style={{ fontSize: "18px" }}
                          >
                            Questions:{" "}
                            <strong>{portfolio.number_of_questions}</strong>
                          </Text>
                          <Text
                            size="medium"
                            color="dark-4"
                            style={{ fontSize: "18px" }}
                          >
                            Learning Paths:{" "}
                            <strong>
                              {portfolio.number_of_learning_paths}
                            </strong>
                          </Text>
                        </Box>
                      </Box>
                    </CardBody>
                    <CardFooter
                      pad={{ horizontal: "small", vertical: "small" }}
                      background="light-2"
                      round={{ corner: "bottom", size: "small" }}
                      style={{
                        borderTop: "1px solid #E0E0E0",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        label="View Portfolio"
                        onClick={() =>
                          handleViewPortfolio(portfolio.portfolio_id)
                        }
                        primary
                        size="small"
                        style={{ padding: "10px 30px", fontSize: "16px" }}
                      />
                    </CardFooter>
                  </Card>
                ))}
              </Grid>

              {/* View More / View Less Button */}
              <Box align="center" margin={{ top: "small" }}>
                <Button
                  label={showAll ? "View Less" : "View More"}
                  onClick={toggleViewMore}
                  size="medium"
                  secondary
                />
              </Box>
            </Box>
          ) : (
            <Box align="center" pad="medium">
              <Text>
                No portfolios available. Please add a new portfolio to see it
                here.
              </Text>
            </Box>
          )}
        </Box>
      </Box>
      <AddNewPortfolioModal 
       showModal={showAddNewPortoflioModal}
       setShowModal={setshowAddNewPortoflioModal}
       onPortfolioCreated={handlePortfolioCreated}
        />
      <QuickStartGuideModal showModal={showModal} setShowModal={setShowModal} />
      <StickyFooter />
    </Box>
  );
};

export default AdminDashboard;
